export const SignUpFormOptions = {
  prefectures: [
    { key: "1", value: "北海道" },
    { key: "2", value: "青森県" },
    { key: "3", value: "岩手県" },
    { key: "4", value: "宮城県" },
    { key: "5", value: "秋田県" },
    { key: "6", value: "山形県" },
    { key: "7", value: "福島県" },
    { key: "8", value: "茨城県" },
    { key: "9", value: "栃木県" },
    { key: "10", value: "群馬県" },
    { key: "11", value: "埼玉県" },
    { key: "12", value: "千葉県" },
    { key: "13", value: "東京都" },
    { key: "14", value: "神奈川県" },
    { key: "15", value: "新潟県" },
    { key: "16", value: "富山県" },
    { key: "17", value: "石川県" },
    { key: "18", value: "福井県" },
    { key: "19", value: "山梨県" },
    { key: "20", value: "長野県" },
    { key: "21", value: "岐阜県" },
    { key: "22", value: "静岡県" },
    { key: "23", value: "愛知県" },
    { key: "24", value: "三重県" },
    { key: "25", value: "滋賀県" },
    { key: "26", value: "京都府" },
    { key: "27", value: "大阪府" },
    { key: "28", value: "兵庫県" },
    { key: "29", value: "奈良県" },
    { key: "30", value: "和歌山県" },
    { key: "31", value: "鳥取県" },
    { key: "32", value: "島根県" },
    { key: "33", value: "岡山県" },
    { key: "34", value: "広島県" },
    { key: "35", value: "山口県" },
    { key: "36", value: "徳島県" },
    { key: "37", value: "香川県" },
    { key: "38", value: "愛媛県" },
    { key: "39", value: "高知県" },
    { key: "40", value: "福岡県" },
    { key: "41", value: "佐賀県" },
    { key: "42", value: "長崎県" },
    { key: "43", value: "熊本県" },
    { key: "44", value: "大分県" },
    { key: "45", value: "宮崎県" },
    { key: "46", value: "鹿児島県" },
    { key: "47", value: "沖縄県" },
  ],
  positions: [
    { key: "0", value: "経営者・役員" },
    { key: "1", value: "部長・課長" },
    { key: "2", value: "主任・リーダー" },
    { key: "3", value: "一般" },
    { key: "4", value: "その他" },
  ],
  industries: [
    { key: "0", value: "製造業" },
    { key: "1", value: "建築業" },
    { key: "2", value: "設備業" },
    { key: "3", value: "運輸業" },
    { key: "4", value: "流通業" },
    { key: "5", value: "農林水産業" },
    { key: "6", value: "印刷・出版業" },
    { key: "7", value: "金融業・保険業" },
    { key: "8", value: "不動産業" },
    { key: "9", value: "IT・情報通信業" },
    { key: "10", value: "サービス業" },
    { key: "11", value: "教育・研究機関" },
    { key: "12", value: "病院・医療機関" },
    { key: "13", value: "官公庁・自治体" },
    { key: "14", value: "法人団体" },
    { key: "15", value: "その他の業種" },
  ],
  tasks: [
    { key: "0", value: "経営" },
    { key: "1", value: "財務・会計・経理" },
    { key: "2", value: "人事・総務・庶務" },
    { key: "3", value: "資材・購買・調達" },
    { key: "4", value: "営業・販売" },
    { key: "5", value: "マーケティング・調査" },
    { key: "6", value: "広報・宣伝" },
    { key: "7", value: "物流・生産管理" },
    { key: "8", value: "コンサルタント" },
    { key: "9", value: "事業企画・営業企画" },
    { key: "10", value: "カスタマーサポート" },
    { key: "11", value: "システム開発" },
    { key: "12", value: "情報システム" },
    { key: "13", value: "研究・企画・開発" },
    { key: "14", value: "編集・設計・デザイン" },
    { key: "15", value: "教員・インストラクタ" },
    { key: "16", value: "その他" },
  ],
  discoverySources: [
    { key: "0", value: "広告" },
    { key: "1", value: "SNS" },
    { key: "2", value: "記事コンテンツ" },
    { key: "3", value: "イベント" },
    { key: "4", value: "ウェビナー・オンラインイベント" },
    { key: "5", value: "メールマガジン" },
    { key: "6", value: "知人・友人・同僚からの紹介" },
    { key: "7", value: "外部サイト" },
    { key: "8", value: "その他" },
  ],
  usage: [
    { key: "0", value: "クラウドIP電話" },
    { key: "1", value: "クリック to コール" },
    { key: "2", value: "通話の録音と文字起こし" },
    { key: "3", value: "SMS送信" },
  ],
  customerKbn: [
    { key: "0", value: "法人" },
    { key: "1", value: "個人事業主" },
    { key: "2", value: "公共団体等" },
  ],
};
